import { useQuery } from '@apollo/react-hooks';
import dayjs from 'dayjs';
import type { OfferDetails, GetOfferDetails } from './types';
import {
  modeOfStudyOptions,
  programmeOptions,
  PROGRAMME_TYPE,
  programmeTypeOptions,
} from '../../components';
import { getOptionsLabel } from '../../../Monitor/components';
import { GET_OFFER_DETAILS } from './GET_OFFER_DETAILS';

export const useGetOfferDetails = (applicationId: string): GetOfferDetails => {
  const { data, loading, error, refetch } = useQuery(GET_OFFER_DETAILS, {
    variables: { applicationId },
    fetchPolicy: 'network-only',
  });
  const {
    status,
    department,
    programme,
    programmeType,
    studyMode,
    programmeCode,
    normalPeriodOfStudy,
    creditRequirement,
    reportingDutyDate,
    commencementDate,
    isFirmOffer,
    supervisor,
    conditions,
    conditionFulfillingDeadline,
    entryYearDisplayName,
    fundingLetter,
    ...others
  } = data?.offer ?? {};

  const departmentList = data?.programmeChoiceMetadata?.departmentList ?? [];

  const offerDetails: OfferDetails = {
    status,
    department: getOptionsLabel(departmentList, department),
    programme:
      programmeType !== PROGRAMME_TYPE.GENERAL_PROGRAMME
        ? getOptionsLabel(programmeTypeOptions, programmeType)
        : getOptionsLabel(programmeOptions, programme),
    studyMode: getOptionsLabel(modeOfStudyOptions, studyMode),
    supervisor,
    programmeCode,
    normalPeriodOfStudy: normalPeriodOfStudy + ' years',
    creditRequirement: creditRequirement + ' credits',
    reportingDutyDate:
      entryYearDisplayName +
      ` (${dayjs(reportingDutyDate).format('D MMMM YYYY')})`,
    commencementDate:
      entryYearDisplayName +
      ` (${dayjs(commencementDate).format('D MMMM YYYY')})`,
    isFirmOffer,
    conditions: (conditions ?? []).map((condition: any) => {
      const { detail, ...othersItems } = condition ?? {};
      return {
        detail: detail ?? 'TBC',
        ...othersItems,
      };
    }),
    conditionFulfillingDeadline: dayjs(conditionFulfillingDeadline).format(
      'D MMMM YYYY',
    ),
    fundingLetter,
    ...others,
    ...(data?.studentParticular ?? {}),
  };

  return { offerDetails, loading, error, refetch };
};
